import { render, staticRenderFns } from "./MapElemInfoNew.vue?vue&type=template&id=6b5d9c7d&scoped=true"
import script from "./MapElemInfoNew.vue?vue&type=script&lang=ts"
export * from "./MapElemInfoNew.vue?vue&type=script&lang=ts"
import style0 from "./MapElemInfoNew.vue?vue&type=style&index=0&id=6b5d9c7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5d9c7d",
  null
  
)

export default component.exports